import Vue from 'vue'
import axios from 'axios'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage);

const state = {
    patientAnswers: [],
    updateStatus: false
};

const getters = {
    patientAnswers(state) {
        return state.patientAnswers;
    },
    updateStatus(state) {
        return state.updateStatus;
    }
};

const mutations = {
    SET_PATIENT_ANSWERS(state, newPatientAnswers) {
        state.patientAnswers = newPatientAnswers;
    },
    ADD_PATIENT_ANSWER(state, patientAnswer) {
        state.patientAnswers.push(patientAnswer);
    },
    SET_UPDATE_STATUS(state, newUpdateStatus) {
        state.updateStatus = newUpdateStatus;
    }
};

const actions = {
    loadPatientAnswers(context) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/patients/${context.getters.cgaPatient.id}/get-answers-per-sheet/${context.getters.cgaPatientSheet.id}`)
                .then(response => {
                    context.commit("SET_PATIENT_ANSWERS", response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    updatePatientAnswers(context) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/patients/${context.getters.cgaPatient.id}/update-answers-per-sheet/${context.getters.cgaPatientSheet.id}`, context.getters.patientAnswers)
                .then(response => {
                    resolve(response);
                    context.commit("SET_UPDATE_STATUS", true);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    setUpdateStatus(context, newUpdateStatus)
    {
        context.commit("SET_UPDATE_STATUS", newUpdateStatus);
    },
    initPatientTextAnswer(context, questionId) {
        context.commit("ADD_PATIENT_ANSWER", {
            "questionId": questionId,
            "textAnswer": null,
            "patientSheetId": context.getters.cgaPatientSheet.id,
            "patientId": context.getters.cgaPatient.id
        });
    }
    
};

export default {
    state,
    getters,
    mutations,
    actions
};